import { createFileRoute } from '@tanstack/react-router';

import VehicleDetailPage from '@src/pages/Fleet/Detail';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/fleet/$vehicleId')({
  head: () => ({
    meta: [
      { title: getLocalizedTitle('fleet.vehicle_details', 'Vehicle details') },
    ],
  }),
  component: VehicleDetailRoute,
});

function VehicleDetailRoute() {
  const { vehicleId } = Route.useParams();
  return <VehicleDetailPage vehicleId={vehicleId} />;
}
